import { jsx as r } from "react/jsx-runtime";
const e = ({ className: l, width: o = "22", height: t = "16" }) => /* @__PURE__ */ r(
  "svg",
  {
    className: l,
    width: o,
    height: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 16",
    children: /* @__PURE__ */ r(
      "path",
      {
        d: "M10.706 13.185a.652.652 0 0 1 0 .943.703.703 0 0 1-.973 0L3.9 8.471A.657.657 0 0 1 3.698 8c0-.177.073-.346.202-.471l5.833-5.657a.703.703 0 0 1 .973 0 .652.652 0 0 1 0 .943l-4.66 4.518h11.57c.379 0 .687.299.687.667a.677.677 0 0 1-.688.667H6.045l4.66 4.518Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  e as default
};
